import React from 'react';

import { Container, Content } from './styles';

const Footer = props => {
  return (
    <Container>
      <Content>{props.children}</Content>
    </Container>
  );
};

export default Footer;
